import { useNavigate } from 'react-router-dom';
import { Card, Icon, toast } from '@pella/sash-framework';
import { useSelectedPlant } from '../../../hooks';

import { SelectPlant } from '../../atoms';

// https://parceljs.org/languages/svg/#importing-as-a-react-component
import Logo from 'jsx:../../../assets/pella_logo.svg';

import * as classes from './Home.module.css';

const LINKS = [
  { title: 'New Request', path: '/request', icon: 'assignment_add' },
  { title: 'Worklist', path: '/worklist', icon: 'assignment' },
  { title: 'Request Status', path: '/request?view=Status', icon: 'checklist_rtl' },
  { title: 'Queues', path: '/worklist?view=Queues', icon: 'list_alt' },
  { title: 'Quick Request', path: '/quick-request', icon: 'auto_awesome' },
];

/**
 * Component for the Home page.
 */
export const Home = () => {
  const navigate = useNavigate();
  const { selectedPlant } = useSelectedPlant();

  /**
   * Handles clicks on the navigation cards.
   * @param {React.MouseEvent<HTMLButtonElement> & { currentTarget: { dataset: { path: string } } }} event - The click event object.
   */
  const handleCardClick = ({ currentTarget: { dataset } }) => {
    const { path } = dataset;

    if (!selectedPlant && path !== '/quick-request') {
      toast.dismiss();
      return toast.error('Please select a plant before proceeding.');
    }

    return navigate(path);
  };

  return (
    <div className={classes.container}>
      <Logo className={classes.logo} />
      <div className={classes.select}>
        <SelectPlant />
      </div>
      <div className={classes.cards}>
        {LINKS.map(({ title, path, icon }) => (
          <button key={path} type='button' data-path={path} onClick={handleCardClick}>
            <Card className={classes.card}>
              <Icon
                name={/** @type {import('material-design-icons-literal-types').MaterialSymbols} */ (icon)}
                size={36}
                weight={700}
              />
              <div className={classes.title}>{title}</div>
            </Card>
          </button>
        ))}
      </div>
    </div>
  );
};
